module.exports = __webpack_public_path__ + "static/media/operador-logo-clinipam.2b3e54c7.svg";